import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useEffect, useState } from "react";
import { colaboradorService } from "../services/ColaboradorService";
import Colaborador from "../types/negocio/Colaborador";

interface SelectColaboradorProps {
  value: string;
  onChange: (colaborador?: Colaborador) => void;
  label?: string;
  fullWidth?: boolean;
  sx?: any;
  disabled?: boolean;
}

const SelectColaborador = ({
  value,
  onChange,
  label = "Responsável",
  fullWidth = true,
  sx = {},
  disabled = false
}: SelectColaboradorProps) => {
  const [colaboradores, setColaboradores] = useState<Colaborador[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchColaboradores = async () => {
      setLoading(true);
      try {
        const data = await colaboradorService.listarTodos();
        setColaboradores(data);
      } catch (error) {
        console.error("Erro ao buscar colaboradores:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchColaboradores();
  }, []);

  const handleChange = (event: SelectChangeEvent) => {
    const guid = event.target.value as string;
    const selectedColaborador = colaboradores.find(col => col.guid === guid);
    onChange(selectedColaborador);
  };

  return (
    <FormControl fullWidth={fullWidth} sx={sx} disabled={loading || disabled}>
      <InputLabel id="responsavel-label">{label}</InputLabel>
      <Select
        labelId="responsavel-label"
        id="responsavel"
        value={value || ''}
        label={label}
        onChange={handleChange}
      >
        <MenuItem value="">
          <em>Selecione um colaborador</em>
        </MenuItem>
        {colaboradores.map((colaborador) => (
          <MenuItem key={colaborador.guid} value={colaborador.guid}>
            {colaborador.nomeCompleto}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectColaborador;
